import { type ForkPageCountry, type ForkPageNavigationProps } from "./ForkPageNavigation";
import { Link } from "../common/components/Link";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useTranslation } from "react-i18next";

export const MobileForkPageNavigation = ({ title, subtitle, regions }: ForkPageNavigationProps) => {
  const { t } = useTranslation();
  const makeLink = ({ title, url, openInNewTab }: ForkPageCountry) => (
    <Link key={title} href={url} target={openInNewTab ? "_blank" : undefined}>
      {t(title)}
    </Link>
  );

  return (
    <div>
      <h1 className="scha__fork__title">{title}</h1>
      <h2 className="scha__fork__subtitle">{subtitle}</h2>

      <div className={"scha__fork__mobile-regions fullbleed"}>
        {regions.map((region) => {
          const countriesPerColumn = Math.floor((region.countries.length + 1) / 2);

          return (
            <Accordion>
              <AccordionSummary>{t(region.title)}</AccordionSummary>
              <AccordionDetails>
                <div className="scha__fork__region__countries">
                  <div className="scha__fork__region__countries__column">
                    {region.countries.slice(0, countriesPerColumn).map(makeLink)}
                  </div>

                  {region.countries.length > countriesPerColumn && (
                    <div className="scha__fork__region__countries__column">
                      {region.countries.slice(countriesPerColumn).map(makeLink)}
                    </div>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
};
